<div class="discount-grid-renderer">
    <span class="discount-with-currency">
        <span>{{ discountedAmount | number: "1.2-2" | noComma }} </span>
        <span>{{this.currency}}</span>
    </span>
    <span class="discout-percentage">
        {{ this.percentage | number: "1.2-2" | noComma }}%
    </span>
</div>